import React from 'react';
import OutsideFormInput from 'components/Input/OutsideFormInput';

interface IM4LoginField {
	value: string;
	settingsId: string;
	onChange: (value: string) => void;
}

const M4LoginField: React.FC<IM4LoginField> = ({ onChange, value, settingsId }) => {
	return (
		<OutsideFormInput
			testId="M4LoginField"
			name="login"
			label="APIProxiLoginLabel"
			errorMessage="enterLogin"
			blockId={settingsId}
			value={value}
			onChange={onChange}
		/>
	);
};

export default React.memo(M4LoginField);
